export class ParticipantDaiaryRequest{
    "patientId":Number;
    "studyId":Number;
    "fromDate":Number;
    "toDate":Number
    "userId":Number
}